import * as React from "react";
import {
    UitkCard,
    UitkHeading,
    UitkMessagingCard, UitkMessagingCardActionTypes,
    UitkText,
} from "@egencia/uitk-react";

const {anonymousUser} = EG.bootstrapped;

export const ContactOptions = () => {
    const callUsTitle = uitk.i18n.msg('contact_info_call_us');
    const contactTitle = uitk.i18n.msg("panel_contact_us_button");
    const emailUsTitle = uitk.i18n.msg('contact_info_email_us');
    const emailLabel = uitk.i18n.msg('contact_info_email_support');

    const caseTitle = uitk.i18n.msg('case_status_title');
    const caseLabel = uitk.i18n.msg('case_status_label');

    const email = EG.bootstrapped.email
    const caseStatus = '/contact-us/case-status';

    const callDisclaimer = uitk.i18n.msg('contact_info_phone_call_notes');
    const phoneNumberList = EG.bootstrapped.phoneNumberList;

    function handleClickEmail() {
        omnitureLog.logClickEvent(EG.pageName + '.EMailSupport.Clicked');
    }

    function handleClickCase() {
        omnitureLog.logClickEvent(EG.pageName + '.ViewCases.Clicked');
    }

    function getPhoneOption() {
        const disclaimer = <UitkText inline="small" size={100}>{callDisclaimer}</UitkText>
        const phoneNumbers = phoneNumberList.map((phone, i) => (phone.dialable ?
                <div key={i}>
                    <a href={`tel:${phone.phoneNumber}`}>{phone.phoneNumber}</a>
                    <UitkText>{phone.secondaryPhoneInfo}</UitkText>
                </div> :
                <div key={i}>
                    <UitkText>{phone.phoneNumber}</UitkText>
                    <UitkText>{phone.secondaryPhoneInfo}</UitkText>
                </div>
        ))
        
        return <div>
            {phoneNumbers}
            {disclaimer}
        </div>
    }

    return (
        <UitkCard padding={"medium"} border={true}>
            <UitkHeading tag={"h2"} size={5}>{contactTitle}</UitkHeading>
            {phoneNumberList && (
                <UitkMessagingCard
                    className={"contact-us-option"}
                    icon={"phone"}
                    headingText={callUsTitle}
                    border={false}
                    textValue={getPhoneOption()}
                    a11yActionLabel="continue"
                    onClickAction={handleClickEmail}
                />
            )}

            {!anonymousUser && EG.analytics.configs['home.display_customer_care_email'].value.display && (
                <UitkMessagingCard
                    className={"email-us-option"}
                    icon={"email"}
                    headingText={emailUsTitle}
                    textValue={emailLabel}
                    border={false}
                    action={UitkMessagingCardActionTypes.navigate}
                    a11yActionLabel="continue"
                    onClickAction={handleClickEmail}
                    bodyUrl={email}
                />
            )}

            {!anonymousUser && EG.analytics.configs['contact_us.case_status_view_enabled'].value && (
                <UitkMessagingCard
                    className={"case-status-option"}
                    icon={"hourglass_empty"}
                    headingText={caseTitle}
                    textValue={caseLabel}
                    border={false}
                    action={UitkMessagingCardActionTypes.navigate}
                    a11yActionLabel="continue"
                    onClickAction={handleClickCase}
                    bodyUrl={caseStatus}
                />
            )}
        </UitkCard>
    )
};